export function parsePeopleNumerSafe(peopleNumberString) {
  let peopleNumberParsed = parseInt(peopleNumberString);
  if(isNaN(peopleNumberParsed)) peopleNumberParsed = 1;
  return peopleNumberParsed;
}
